import { render, staticRenderFns } from "./RequestsView.vue?vue&type=template&id=106709be&"
import script from "./RequestsView.vue?vue&type=script&lang=js&"
export * from "./RequestsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports